const WHITELIST = ['development', 'staging'];

export const debug = (message: any, prefix?: string) => {
  if (!WHITELIST.includes(import.meta.env.VITE_ENVIRONMENT as string)) {
    return;
  }

  if (prefix) {
    console.debug(`[${prefix}]:`, message);
  } else {
    console.debug(message);
  }
};
